export enum UserSessionType {
    ActingUser = 'current',
    LoggedInUser = 'loggedin'
}
